import React, { PropsWithChildren } from 'react';

export type CommonProps = PropsWithChildren<{
  variant?: 'white' | 'black' | 'black-regular' | 'white-regular';
  isSmall?: boolean;
}>;

type TextLinkButtonProps = CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>;
type TextLinkAnchorProps = CommonProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    isExternal?: boolean;
  };
export type TextLinkProps = TextLinkButtonProps | TextLinkAnchorProps;

export const isTextLinkButton = (props: TextLinkProps): props is TextLinkButtonProps => !('href' in props);
